var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFromReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.25C25.4746 0.25 32.75 7.52537 32.75 16.5C32.75 25.4746 25.4746 32.75 16.5 32.75C7.52537 32.75 0.25 25.4746 0.25 16.5C0.25 7.52537 7.52537 0.25 16.5 0.25Z",
    fill: "#0B45DB",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.25C25.4746 0.25 32.75 7.52537 32.75 16.5C32.75 25.4746 25.4746 32.75 16.5 32.75C7.52537 32.75 0.25 25.4746 0.25 16.5C0.25 7.52537 7.52537 0.25 16.5 0.25Z",
    stroke: "#0B45DB",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3438 10.2227C17.0938 9.97263 16.7547 9.83211 16.4011 9.83203H11.6198C11.2662 9.83203 10.927 9.97251 10.677 10.2226C10.4269 10.4726 10.2865 10.8117 10.2865 11.1654V15.9467C10.2865 16.3003 10.4271 16.6394 10.6771 16.8894L16.4798 22.692C16.7828 22.9931 17.1926 23.1621 17.6198 23.1621C18.047 23.1621 18.4568 22.9931 18.7598 22.692L23.1465 18.3054C23.4476 18.0024 23.6166 17.5925 23.6166 17.1654C23.6166 16.7382 23.4476 16.3284 23.1465 16.0254L17.3438 10.2227Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 13.8346C14.1372 13.8346 14.2864 13.6854 14.2864 13.5013C14.2864 13.3172 14.1372 13.168 13.9531 13.168C13.769 13.168 13.6198 13.3172 13.6198 13.5013C13.6198 13.6854 13.769 13.8346 13.9531 13.8346Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromReport);
export default __webpack_public_path__ + "static/media/from-report.656013d4d32351c6eff7ef5d41ca4f8c.svg";
export { ForwardRef as ReactComponent };